import { Component, Input } from '@angular/core';

@Component({
  selector: 'evrideo-step-backward-icon',
  templateUrl: './step-backward-icon.component.html',
  styleUrls: ['./step-backward-icon.component.scss'],
})
export class StepBackwardIconComponent {
  @Input()
  overrideStyle: Record<string, string> = {};
}
